import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import ModuleList from './components/module/ModuleList'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/:moduleName',
      name: 'ModuleList',
      props: true,
      component: ModuleList
    },
    {
      path: '/:moduleName/form/:id',
      name: 'ModuleList',
      props: true,
      component: ModuleList
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
